import path from 'node:path'
import { removedDir } from './removed-dir.js'

export function tombstonePath(cwd: string, scope: string): string {
  return path.join(removedDir(cwd), scope)
}
